import angular from 'angular'
import webskedPitchesComponent from './webskedPitches.component'

export default angular
  .module('ellipsis.webskedPitches', [])
  .component('webskedPitches', webskedPitchesComponent)
